import Navbar from "@/components/feature/Navbar";

import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";

import Footer from "../../components/feature/Footer";
//import PageBanner from "../../components/base/PageBanner";

import {
  BaseUrl,
  Unichat_Url,
  AUTH_KEY,
  apiUrl_dialerp,
  subID,
  Appname,
  setLogindata,
  setUserdata,
  LoggedInUserID,
  LoggedInUserName,
} from "../../Services/Urls";
import {
  makeApiRequest,
  callApi,
  makeApiRequest_seperateDb,
  makeApiRequest_seperateDb_get,
} from "../../Services/ApiService";

import { getRecords, PostRecords } from "../../Services/ApiCall";
import { decryptOtp, getUser, formatDisplayDate } from "../../Services/Helper";

import { useContext } from "react";
import { ApiContext } from "../../Context/Context";

const NewsResearchPage = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState<"news" | "research">("news");
  const [selectedCategory, setSelectedCategory] = useState<string>("All");
  const [contentItems, setContentItems] = useState<any[]>([
    "All",
    "News Feeds",
    "Announcements",
    "Product Launches",
    "Achievements",
    "Events",
    "Press Releases",
    "Research & Innovation",
  ]);
  const [Researchdata, setResearchdata] = useState<any[]>([]);

  const newsCategories = [
    "All",
    "News Feeds",
    "Announcements",
    "Product Launches",
    "Achievements",
    "Events",
    "Press Releases",
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    getdata();
    // const savedContent = localStorage.getItem('radhey-content');
    // if (savedContent) {
    //   const parsed = JSON.parse(savedContent);
    //   setContentItems(parsed);
    // } else {
    //   const allContent = [...defaultNewsData, ...defaultResearchData];
    //   setContentItems(allContent);
    //   localStorage.setItem('radhey-content', JSON.stringify(allContent));
    // }
  }, []);

  const getdata = () => {
    let url = `${Unichat_Url}/universaldairy/user`;

    makeApiRequest_seperateDb(
      url,
      (response: any) => {
        if (response?.success === true) {
          setResearchdata(response?.records);
        } else {
        }
      },
      (error: any) => {},
    );
  };

  const newsItems = contentItems
    .filter((item) => item.category !== "Research & Innovation")
    .sort((a, b) => b.createdAt - a.createdAt);

  const researchItems = contentItems
    .filter((item) => item.category === "Research & Innovation")
    .sort((a, b) => b.createdAt - a.createdAt);

  const filteredNews =
    selectedCategory === "All"
      ? newsItems
      : newsItems.filter((item) => item.category === selectedCategory);

  const filteredData = Researchdata?.filter((item: any) => {
    // Filter by tab
    const tabMatch =
      activeTab === "news"
        ? item.Category !== "Research & Innovation"
        : item.Category === "Research & Innovation";

    // Filter by category
    const categoryMatch =
      selectedCategory === "All" || item.Category === selectedCategory;

    return tabMatch && categoryMatch;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative pt-20 pb-20 bg-gradient-to-br from-[#1A2B4A] to-[#00B8A9]">
        <div className="max-w-7xl mx-auto px-6">
          <h1 className="text-6xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Media
          </h1>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Tab Navigation */}
          {/* <div className="flex justify-center mb-12">
            <div className="inline-flex bg-gray-100 rounded-full p-1">
              <button
                onClick={() => setActiveTab("news")}
                className={`px-8 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === "news"
                    ? "bg-primary text-white shadow-md"
                    : "text-gray-600 hover:text-primary"
                }`}
              >
                <i className="ri-newspaper-line mr-2"></i>
                News Feeds
              </button>
              <button
                onClick={() => setActiveTab("research")}
                className={`px-8 py-3 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                  activeTab === "research"
                    ? "bg-primary text-white shadow-md"
                    : "text-gray-600 hover:text-primary"
                }`}
              >
                <i className="ri-flask-line mr-2"></i>
                Research &amp; Innovation
              </button>
            </div>
          </div> */}

          {/* News Section */}
          {activeTab === "news" && (
            <div>
              <div className="text-center mb-10">
                <h2 className="text-3xl font-bold text-gray-800 mb-4">
                  Latest Media
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto text-justify">
                  Stay updated with the latest announcements, press releases,
                  product launches, and achievements from Universal Dairy.
                </p>
              </div>

              {/* Category Filter */}
              <div className="flex flex-wrap justify-center gap-3 mb-10">
                {contentItems?.map((category) => (
                  <button
                    key={category}
                    onClick={() => setSelectedCategory(category)}
                    className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                      selectedCategory === category
                        ? "bg-[#0a7f82] text-white"
                        : "bg-gray-100 text-gray-600 hover:bg-[#0a7f82]/10 hover:text-[#0a7f82]"
                    }`}
                  >
                    {category}
                  </button>
                ))}
              </div>

              {/* News Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredData?.map((item, i) => (
                  <article
                    key={item._id}
                    className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100"
                  >
                    {item.Images && (
                      <div className="w-full h-48 overflow-hidden">
                        <img
                          src={item.Images}
                          alt={item.title}
                          className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                        />
                      </div>
                    )}
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-3">
                        <span className="px-3 py-1 bg-primary/10 text-primary text-xs font-medium rounded-full whitespace-nowrap">
                          {item.Category}
                        </span>
                        <span className="text-xs text-gray-500 flex items-center whitespace-nowrap">
                          <i className="ri-calendar-line mr-1"></i>
                          {formatDisplayDate(item.Date || "")}
                        </span>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-800 mb-3 line-clamp-2">
                        {item.Title}
                      </h3>
                      <p className="text-sm text-gray-600 line-clamp-3 mb-4">
                        {item.Summary || item.Description}
                      </p>

                      <Link
                        to={`/news-research-details/${item._id}`}
                        className="text-primary text-sm font-medium hover:underline cursor-pointer whitespace-nowrap"
                      >
                        Read More <i className="ri-arrow-right-line ml-1"></i>
                      </Link>
                    </div>
                  </article>
                ))}
              </div>

              {filteredData.length === 0 && (
                <div className="text-center py-12">
                  <i className="ri-newspaper-line text-4xl text-gray-300 mb-4"></i>
                  <p className="text-gray-500">
                    No news items found in this category.
                  </p>
                </div>
              )}
            </div>
          )}

          {/* Research Section */}
          {activeTab === "research" && (
            <div>
              <div className="text-center mb-10">
                <h2 className="text-3xl font-bold text-gray-800 mb-4">
                  Research &amp; Innovation
                </h2>
                <p className="text-gray-600 max-w-2xl mx-auto text-justify">
                  Explore our cutting-edge research work, innovative studies,
                  lab findings, and product development initiatives at Radhey
                  Biotech.
                </p>
              </div>

              {/* Research Grid */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {filteredData?.map((item, i) => (
                  <article
                    key={item._id}
                    className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 border border-gray-100 flex flex-col md:flex-row"
                  >
                    {item.Images && (
                      <div className="w-full md:w-64 h-48 md:h-auto flex-shrink-0 overflow-hidden">
                        <img
                          src={item.Images}
                          alt={item.Title}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                    )}
                    <div className="p-6 flex flex-col justify-between">
                      <div>
                        <div className="flex items-center mb-3">
                          <i className="ri-flask-line text-primary mr-2"></i>
                          <span className="text-xs text-gray-500 whitespace-nowrap">
                            {formatDisplayDate(item.Date || "")}
                          </span>
                        </div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-3">
                          {item.Title}
                        </h3>
                        <p className="text-sm text-gray-600 mb-4">
                          {item.Summary || item.Description}
                        </p>
                      </div>
                      <div className="flex items-center gap-4">
                        <button
                          onClick={() =>
                            navigate(`/news-research-details/${item._id}`)
                          }
                          className="text-primary text-sm font-medium hover:underline cursor-pointer whitespace-nowrap"
                        >
                          Learn More{" "}
                          <i className="ri-arrow-right-line ml-1"></i>
                        </button>
                        {item.Docs && (
                          <button
                            onClick={() => {
                              if (!item?.Docs) return;

                              const link = document.createElement("a");
                              link.href = item.Docs;
                              link.download = "document.pdf"; // optional custom filename
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }}
                            className="flex items-center text-sm text-gray-600 hover:text-primary transition-colors cursor-pointer whitespace-nowrap"
                          >
                            <i className="ri-file-pdf-line mr-1"></i>
                            Download PDF
                          </button>
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </div>

              {filteredData.length === 0 && (
                <div className="text-center py-12">
                  <i className="ri-flask-line text-4xl text-gray-300 mb-4"></i>
                  <p className="text-gray-500">No research items found.</p>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default NewsResearchPage;
